import { ZodError, ZodIssue, ZodSchema } from 'zod';

const FALLBACK_ENV_VAR = 'error_getting_env';

type Env = {
  [key: string]: string | undefined;
};

const getFallbackEnv = (env: Env, issues?: Array<ZodIssue>) => {
  const envVarsWithIssues = issues?.flatMap(({ path }) => path);
  return Object.entries(env).reduce<Env>(
    (accumulator, [currentKey, currentValue]) => {
      if (envVarsWithIssues?.includes(currentKey) || !currentValue) {
        accumulator[currentKey] = FALLBACK_ENV_VAR;
      }
      return accumulator;
    },
    { ...env },
  );
};
const isZodError = (error: unknown): error is ZodError => {
  return (
    error !== null &&
    typeof error === 'object' &&
    'name' in error &&
    error.name === 'ZodError' &&
    'issues' in error &&
    Array.isArray(error.issues)
  );
};

export const parseEnv = (env: Env, envSchema: ZodSchema) => {
  try {
    const result = envSchema.parse(env);
    return result;
  } catch (error) {
    if (isZodError(error)) {
      console.error({
        message: 'Apps/client environment variables validation error',
        issues: error.issues,
      });
      return getFallbackEnv(env, error.issues);
    }
    return getFallbackEnv(env);
  }
};
